import { v4 as uuidv4 } from 'uuid';

/**
 * Adds a unique identifier {UUID} to each item in a list.
 *
 * @param {Array} listToAddIds The list of items to which unique IDs should be added
 * It is expected to be a list of objects
 *
 * @returns {Array} a new list where each item has a unique 'id' property,
 * If an item already contains an 'id', it will not be overwritten.
 * Otherwhise, a new UUID will be generated and assigned to the 'ID' property
 */
const addUniqueIDstoList = (listToAddIds) => {
  const resultWithId = listToAddIds.map((listItem) => ({
    ...listItem,
    id: listItem.id || uuidv4(),
  }));

  return resultWithId;
};

export default addUniqueIDstoList;
